export type FestivalSettings = {
  mobilePageSize: number;
  desktopPageSize: number;
  backgroundColor: string;
};

export const DEFAULT_FESTIVAL_SETTINGS: FestivalSettings = {
  mobilePageSize: 4,
  desktopPageSize: 12,
  backgroundColor: '#F6F5F2',
};

const MOBILE_PAGE_SIZES = new Set([3, 4]);
const DESKTOP_PAGE_SIZES = new Set([6, 8, 12]);
const COLOR = /^#[0-9A-Fa-f]{6}$/;

export function normalizeFestivalSettings(value: Partial<FestivalSettings> | null | undefined): FestivalSettings {
  return {
    mobilePageSize: MOBILE_PAGE_SIZES.has(value?.mobilePageSize ?? 0)
      ? value!.mobilePageSize!
      : DEFAULT_FESTIVAL_SETTINGS.mobilePageSize,
    desktopPageSize: DESKTOP_PAGE_SIZES.has(value?.desktopPageSize ?? 0)
      ? value!.desktopPageSize!
      : DEFAULT_FESTIVAL_SETTINGS.desktopPageSize,
    backgroundColor: COLOR.test(value?.backgroundColor ?? '')
      ? value!.backgroundColor!.toUpperCase()
      : DEFAULT_FESTIVAL_SETTINGS.backgroundColor,
  };
}

export function paginateFestivalItems<T>(items: T[], pageSize: number): T[][] {
  if (!Number.isInteger(pageSize) || pageSize < 1) return [items];
  return Array.from({ length: Math.ceil(items.length / pageSize) }, (_, index) =>
    items.slice(index * pageSize, (index + 1) * pageSize),
  );
}

export function getFestivalPage<T>(items: T[], pageSize: number, pageIndex: number): T[] {
  const pages = paginateFestivalItems(items, pageSize);
  if (!pages.length) return [];
  const safeIndex = Math.min(Math.max(0, Math.trunc(pageIndex)), pages.length - 1);
  return pages[safeIndex];
}

export function listFestivalCategories(items: Array<{ category?: string }>, orderedNames: string[] = []): Array<{ name: string; count: number }> {
  const counts = new Map<string, number>();
  for (const item of items) {
    const name = item.category?.trim() || '其他';
    counts.set(name, (counts.get(name) || 0) + 1);
  }
  const rows = Array.from(counts, ([name, count]) => ({ name, count }));
  const order = new Map(orderedNames.map((name, index) => [name, index]));
  return rows.sort((left, right) => (order.get(left.name) ?? Number.MAX_SAFE_INTEGER) - (order.get(right.name) ?? Number.MAX_SAFE_INTEGER));
}
